import  React, { Component } from 'react';
import moment from "moment-jalaali";
import {connect} from 'react-redux';
import {default as timemoment} from "moment";
import airplane from "../../image/airplane.svg";
import {Tooltip} from 'antd';
import LayoutConfig from '../../Config/layoutConfig';

class RouteItem extends Component{
    render(){
        const {Dictionary,LAN}=this.props;
        const firstSegment = this.props.model.flightSegments[0];
        const lastSegment = this.props.model.flightSegments[this.props.model.flightSegments.length-1];

        // let destinationTime = moment(lastSegment.arrivalDateTime,"YYYY-MM-DDTHH:mm:SS").format("YYYY-MM-DD");
        // let originTime = moment(firstSegment.departureDateTime,"YYYY-MM-DDTHH:mm:SS").format("YYYY-MM-DD");
        // let c = moment(destinationTime).diff(moment(originTime),'days');

        const isStyle3 = LayoutConfig.themeClassName === 'style-3';
        
        return(
            <div className={"route-item"}>
                <div className="route-item-flex">
                    <div className="air-line-info">
                        <div className="air-line-info-inner">
                            <div className="airline-logo-holder">
                                <img src={firstSegment.marketingAirline.photoUrl} alt={firstSegment.marketingAirline.name} className="airline-logo"/>
                            </div>
                            {this.props.isPackage || <div className={"airlineInfo"}>
                                <div className={"airlinename"}>{firstSegment.marketingAirline.name}</div>
                                <div className={"flightnumber en-font"}>{firstSegment.flightNumber}</div>
                            </div>}
                        </div>
                    </div>
                    <div>
                        <div className="router">
                            <div className="originInfo">
                                <div className="time">
                                    <strong>{moment(firstSegment.departureDateTime).format("HH:mm")}</strong>
                                </div>
                                <div className="date">
                                    <Tooltip placement="top" title=
                                        {(LAN === "IR")?<>
                                        <div>{moment(firstSegment.departureDateTime).format("jYYYY-jMM-jDD")}</div>
                                        <span className="font-12"> ({moment(firstSegment.departureDateTime).format("YYYY-MM-DD")})</span>
                                        </>
                                        :
                                        moment(firstSegment.departureDateTime).format("YYYY-MM-DD")}                                                    
                                        >
                                        <strong className="font-14">
                                            {(LAN === "IR")?
                                            moment(firstSegment.departureDateTime).format("ddd، jD jMMMM")
                                            :
                                            moment(firstSegment.departureDateTime).format("ddd, MMM D")
                                            }
                                        </strong>
                                    </Tooltip> 
                                </div>
                                <div className="codeCity">
                                    <Tooltip title={<div>
                                            <span>{firstSegment.departureAirport.cityName}, </span>
                                            <span>{firstSegment.departureAirport.countryName} -  </span>
                                            {firstSegment.departureAirport.locationName}
                                        </div>}>
                                        {firstSegment.departureAirport.locationCode}
                                    </Tooltip>
                                </div>
                            </div>
                            <div className="stop-info text-center">
                                <div className="stop">{(this.props.model.flightSegments.length-1===0)? <span className={isStyle3?"golden":"green"}>{Dictionary.direct}</span> : <span>{this.props.model.flightSegments.length-1} {Dictionary.stops}</span>}</div>
                                <div className="dashed-line">
                                    <img src={airplane} alt="airplane" title={"airplane"}/>
                                </div>
                                <div className="duration">
                                    {(this.props.model.journeyDuration==="00:00:00")?"-- : --":
                                    <>
                                        <span>{Dictionary.journeyDuration}  </span>
                                        <span className="semi-bold"> {
                                        ((this.props.model.journeyDuration).indexOf(".")>0)?
                                        timemoment(this.props.model.journeyDuration, "d.HH:mm:ss").format("d[d] H[h] m[m]")
                                        :timemoment(this.props.model.journeyDuration, "HH:mm:ss").format("H[h] m[m]")
                                        }
                                        </span>
                                    </>}
                                </div>
                            </div>
                            <div className="destinationInfo text-end">
                                <div className="time">
                                    <strong className="relative">
                                        {(lastSegment.arrivalDateTime === '0001-01-01T00:00:00')?" -- : -- ":  moment(lastSegment.arrivalDateTime).format("HH:mm")}
                                        {/* {(c > 0)?
                                        <span className="font-12 diff-days"> +{c} </span>
                                        :null} */}
                                    </strong>
                                </div>
                                <div className="date">
                                    <Tooltip placement="top" title=
                                        {(lastSegment.arrivalDateTime === '0001-01-01T00:00:00')?undefined: 
                                        (LAN === "IR")?<>
                                        <div>{moment(lastSegment.arrivalDateTime).format("jYYYY-jMM-jDD")}</div>
                                        <span className="font-12"> ({moment(lastSegment.arrivalDateTime).format("YYYY-MM-DD")})</span>
                                        </>
                                        :
                                        moment(lastSegment.arrivalDateTime).format("YYYY-MM-DD")}
                                        >
                                        <strong className="font-14">
                                            {(lastSegment.arrivalDateTime === '0001-01-01T00:00:00')?
                                                " ------ "
                                            :
                                                (LAN === "IR")?
                                                moment(lastSegment.arrivalDateTime).format("ddd، jD jMMMM")
                                                :
                                                moment(lastSegment.arrivalDateTime).format("ddd, MMM D")
                                            }
                                        </strong>

                                    </Tooltip> 
                                </div>
                                <div className="codeCity">
                                    <Tooltip placement="top" title={<div>
                                            <span>{lastSegment.arrivalAirport.cityName}, </span>
                                            <span>{lastSegment.arrivalAirport.countryName} -  </span>
                                            {lastSegment.arrivalAirport.locationName}
                                        </div>}>
                                        {lastSegment.arrivalAirport.locationCode}
                                    </Tooltip>                                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps=(state)=>({
    Dictionary:state.VisualData.Dictionary,
    LAN:state.VisualData.LAN
});
export default connect(mapStateToProps)(RouteItem);